// Mock data for Dr. LOUNIS KHODJA Medical Website

export const doctorInfo = {
  name: "Dr LOUNIS KHODJA",
  fullName: "Dr LOUNIS KHODJA Mounir Abderrahmane",
  title: "Chirurgien spécialiste en chirurgie mini-invasive",
  tagline: "Une chirurgie raisonnée, fondée sur la science, l'expérience et l'éthique médicale.",
  phone: "+213 671 479 498",
  email: "louniskhodja.ma@gmail.com",
  address: "1, bâtiment A cité Armaf, El Magharia, Hussein Dey, Alger",
  hours: "Lundi - Vendredi: 9h00 - 18h00"
};

export const navigation = [
  { name: "Accueil", href: "/" },
  { name: "À propos", href: "/a-propos" },
  { name: "Expertises", href: "/expertises" },
  { name: "Comprendre", href: "/comprendre" },
  { name: "Publications", href: "/publications" },
  { name: "Témoignages", href: "/temoignages" },
  { name: "Contact", href: "/contact" }
];

export const introduction = {
  title: "Une approche médicale centrée sur le patient",
  text: "Spécialiste en chirurgie générale et digestive, je m'engage à proposer une prise en charge personnalisée, où chaque décision chirurgicale est mûrement réfléchie et discutée avec le patient."
};

export const philosophy = {
  title: "Ma philosophie médicale",
  points: [
    {
      title: "Écoute et dialogue",
      description: "Chaque patient est unique. Je prends le temps d'écouter, de comprendre et d'expliquer pour que vous soyez acteur de votre parcours de soins."
    },
    {
      title: "Chirurgie raisonnée",
      description: "Opérer uniquement quand c'est nécessaire. La chirurgie n'est proposée qu'après avoir évalué toutes les alternatives thérapeutiques."
    },
    {
      title: "Excellence technique",
      description: "Formation continue et maîtrise des techniques mini-invasives pour minimiser les traumatismes et optimiser la récupération."
    }
  ]
};

export const expertises = [
  {
    id: "chirurgie-biliaire",
    title: "Chirurgie biliaire",
    shortDesc: "Traitement des pathologies de la vésicule et des voies biliaires par voie cœlioscopique.",
    fullDesc: "La chirurgie biliaire traite les affections de la vésicule biliaire et des voies biliaires. La cholécystectomie par cœlioscopie est devenue le traitement de référence des calculs vésiculaires symptomatiques.",
    whenConsult: [
      "Douleurs abdominales droites récurrentes",
      "Diagnostic de calculs biliaires",
      "Cholécystite aiguë ou chronique",
      "Complications des lithiases biliaires"
    ],
    alternatives: [
      "Surveillance active pour les calculs asymptomatiques",
      "Traitement médicamenteux de la douleur",
      "Modifications diététiques"
    ],
    notIndicated: [
      "Calculs asymptomatiques découverts fortuitement",
      "Contre-indications anesthésiques majeures"
    ]
  },
  {
    id: "chirurgie-parietale",
    title: "Chirurgie pariétale",
    shortDesc: "Réparation des hernies inguinales, ombilicales et de la paroi abdominale.",
    fullDesc: "La chirurgie pariétale corrige les défauts de la paroi abdominale. Les techniques mini-invasives permettent une récupération rapide avec des cicatrices minimes.",
    whenConsult: [
      "Tuméfaction ou bosse à l'aine ou au nombril",
      "Douleur à l'effort ou en toussant",
      "Hernie diagnostiquée par votre médecin",
      "Gêne fonctionnelle quotidienne"
    ],
    alternatives: [
      "Surveillance pour les petites hernies asymptomatiques",
      "Port d'une ceinture de contention (temporaire)",
      "Renforcement musculaire adapté"
    ],
    notIndicated: [
      "Hernies asymptomatiques chez les patients fragiles",
      "Risque anesthésique élevé"
    ]
  },
  {
    id: "proctologie",
    title: "Proctologie et laser",
    shortDesc: "Traitement des pathologies ano-rectales avec techniques laser modernes.",
    fullDesc: "La proctologie traite les affections de l'anus et du rectum. Les techniques laser permettent des interventions moins invasives avec une meilleure récupération.",
    whenConsult: [
      "Douleurs anales persistantes",
      "Saignements lors des selles",
      "Hémorroïdes symptomatiques",
      "Fissures ou fistules anales"
    ],
    alternatives: [
      "Traitements médicaux locaux",
      "Régularisation du transit",
      "Modifications alimentaires et hygiène de vie"
    ],
    notIndicated: [
      "Symptômes mineurs et transitoires",
      "Pathologies nécessitant un bilan complémentaire préalable"
    ]
  },
  {
    id: "coelioscopie",
    title: "Chirurgie laparoscopique avancée",
    shortDesc: "Interventions abdominales complexes par voie mini-invasive.",
    fullDesc: "La chirurgie laparoscopique utilise de petites incisions et une caméra pour opérer. Cette approche réduit la douleur, les cicatrices et le temps de récupération.",
    whenConsult: [
      "Pathologie abdominale nécessitant une intervention",
      "Recherche d'une approche moins invasive",
      "Seconde opinion sur une indication opératoire"
    ],
    alternatives: [
      "Traitement médical selon la pathologie",
      "Surveillance active",
      "Approche chirurgicale conventionnelle si nécessaire"
    ],
    notIndicated: [
      "Certaines urgences nécessitant un abord ouvert",
      "Adhérences majeures post-opératoires"
    ]
  }
];

export const affiliations = [
  "Membre de l'EAES (European Association for Endoscopic Surgery)",
  "Membre de l'IFSO (International Federation for the Surgery of Obesity)",
  "Membre de SAGES (Society of American Gastrointestinal and Endoscopic Surgeons)",
  "Membre de WALS (World Association of Laparoscopic Surgeons)",
  "Membre de la SACP (Société Algérienne de Chirurgie de la Paroi)",
  "Membre de la SAC (Société Algérienne de Chirurgie)"
];

export const aboutContent = {
  vision: {
    title: "Ma vision de la médecine",
    text: "La chirurgie est un acte grave qui ne doit jamais être banalisé. Mon engagement est de n'opérer que lorsque c'est véritablement nécessaire, en privilégiant toujours les alternatives moins invasives quand elles existent. Je crois en une médecine du dialogue, où le patient comprend sa pathologie et participe aux décisions concernant sa santé."
  },
  background: {
    title: "Parcours professionnel",
    items: [
      "Diplôme de Docteur en Médecine",
      "Spécialisation en Chirurgie Générale et Digestive",
      "Formation complémentaire en chirurgie laparoscopique avancée",
      "Diplôme universitaire de proctologie",
      "Exercice en milieu hospitalier et libéral"
    ]
  },
  education: {
    title: "Formation continue",
    text: "Je participe régulièrement à des congrès scientifiques, des formations et des ateliers pratiques pour maintenir mes compétences au plus haut niveau et intégrer les avancées techniques validées par la recherche."
  },
  ethics: {
    title: "Éthique et déontologie",
    text: "Je m'engage à respecter scrupuleusement le code de déontologie médicale. La confidentialité, le respect de l'autonomie du patient et le refus de toute forme de sur-traitement guident ma pratique quotidienne."
  }
};

export const comprendreContent = {
  intro: {
    title: "Comprendre avant d'opérer",
    text: "La décision chirurgicale doit être éclairée et partagée. Cette page vous aide à comprendre quand la chirurgie est pertinente et quand d'autres options existent."
  },
  whenNecessary: {
    title: "Quand la chirurgie est nécessaire",
    points: [
      "Urgences chirurgicales (appendicite, péritonite, occlusion...)",
      "Échec des traitements médicaux bien conduits",
      "Risque de complications graves sans intervention",
      "Altération significative de la qualité de vie",
      "Diagnostic histologique nécessaire (biopsie)"
    ]
  },
  whenNot: {
    title: "Quand la chirurgie N'EST PAS indiquée",
    points: [
      "Symptômes mineurs ou transitoires",
      "Alternatives médicales non encore essayées",
      "Risque opératoire supérieur au bénéfice attendu",
      "Découverte fortuite sans symptôme (dans de nombreux cas)",
      "Demande motivée par l'anxiété plutôt que par une indication médicale"
    ]
  },
  misconceptions: {
    title: "Idées reçues à corriger",
    items: [
      {
        myth: "La cœlioscopie, c'est pas une vraie opération",
        reality: "C'est une technique chirurgicale à part entière, avec les mêmes risques potentiels qu'une chirurgie ouverte."
      },
      {
        myth: "Il faut opérer vite avant que ça s'aggrave",
        reality: "La plupart des pathologies permettent une réflexion et un bilan complet avant de décider d'opérer."
      },
      {
        myth: "Le chirurgien sait mieux que moi ce qu'il faut faire",
        reality: "La décision est partagée. Vous avez le droit de poser des questions, demander du temps et solliciter un second avis."
      }
    ]
  },
  followUp: {
    title: "L'importance du suivi",
    text: "Une intervention chirurgicale n'est pas une fin en soi. Le suivi post-opératoire est essentiel pour vérifier la bonne cicatrisation, détecter d'éventuelles complications et répondre à vos questions. Je reste disponible pour mes patients après l'opération."
  }
};

export const publications = [
  {
    id: 1,
    title: "Calculs biliaires : quand faut-il opérer ?",
    excerpt: "La découverte de calculs dans la vésicule biliaire est fréquente. Mais tous les calculs ne nécessitent pas une intervention chirurgicale...",
    date: "15 janvier 2025",
    category: "Chirurgie biliaire"
  },
  {
    id: 2,
    title: "Les hernies inguinales : comprendre pour mieux décider",
    excerpt: "Une hernie inguinale est un défaut de la paroi abdominale. Découvrez les signes d'alerte et les options de traitement...",
    date: "3 février 2025",
    category: "Chirurgie pariétale"
  },
  {
    id: 3,
    title: "Le laser en proctologie : une révolution ?",
    excerpt: "Les techniques laser offrent de nouvelles perspectives pour traiter les pathologies hémorroïdaires et les fistules anales...",
    date: "20 février 2025",
    category: "Proctologie"
  },
  {
    id: 4,
    title: "Récupération améliorée après chirurgie (RAAC)",
    excerpt: "Les protocoles de réhabilitation précoce permettent de réduire la durée d'hospitalisation et d'améliorer le confort des patients...",
    date: "10 mars 2025",
    category: "Général"
  }
];

export const faq = [
  {
    question: "Combien de temps dure une cholécystectomie ?",
    answer: "L'intervention dure généralement entre 30 et 60 minutes. L'hospitalisation est courte, souvent en ambulatoire ou une nuit."
  },
  {
    question: "Quand puis-je reprendre mes activités après une opération de hernie ?",
    answer: "La reprise des activités légères est possible après quelques jours. Les activités physiques intenses sont à éviter pendant 4 à 6 semaines."
  },
  {
    question: "Les traitements laser sont-ils douloureux ?",
    answer: "Les techniques laser sont généralement moins douloureuses que la chirurgie conventionnelle. Des antalgiques simples suffisent dans la plupart des cas."
  },
  {
    question: "Puis-je demander un second avis ?",
    answer: "Absolument. Le second avis médical est un droit du patient. Je l'encourage même dans les situations complexes ou lorsque vous avez des doutes."
  }
];

export const testimonials = [
  {
    id: 1,
    initials: "M.D.",
    text: "J'appréhendais beaucoup mon opération de la vésicule. Le Dr Lounis Khodja a pris le temps de tout m'expliquer et de me rassurer. L'intervention s'est très bien passée.",
    context: "Cholécystectomie"
  },
  {
    id: 2,
    initials: "P.R.",
    text: "Après des années de gêne avec ma hernie, j'ai enfin consulté. Le docteur ne m'a pas poussé à l'opération, on a d'abord essayé d'autres solutions. Quand on a décidé d'opérer, j'étais en confiance.",
    context: "Cure de hernie inguinale"
  },
  {
    id: 3,
    initials: "S.L.",
    text: "Un médecin qui écoute vraiment. Pas de jargon incompréhensible, des explications claires et une vraie disponibilité pour le suivi post-opératoire.",
    context: "Suivi post-opératoire"
  },
  {
    id: 4,
    initials: "A.B.",
    text: "J'avais consulté plusieurs chirurgiens avant. Le Dr Lounis Khodja est le seul qui m'a clairement dit que mon cas ne nécessitait pas d'opération. J'ai apprécié cette honnêteté.",
    context: "Consultation"
  }
];

export const contactInfo = {
  consultation: {
    title: "Consultation",
    address: "Cabinet médical\n1, bâtiment A cité Armaf\nEl Magharia, Hussein Dey\nAlger",
    access: "Accès facile en transport",
    parking: "Parking disponible à proximité"
  },
  hours: {
    title: "Horaires de consultation",
    schedule: [
      { day: "Lundi", hours: "9h00 - 13h00 / 14h00 - 18h00" },
      { day: "Mardi", hours: "9h00 - 13h00" },
      { day: "Mercredi", hours: "14h00 - 18h00" },
      { day: "Jeudi", hours: "9h00 - 13h00 / 14h00 - 18h00" },
      { day: "Vendredi", hours: "9h00 - 13h00" }
    ]
  },
  process: {
    title: "Parcours patient",
    steps: [
      {
        step: 1,
        title: "Prise de rendez-vous",
        description: "Contactez le secrétariat par téléphone pour convenir d'un rendez-vous selon vos disponibilités."
      },
      {
        step: 2,
        title: "Première consultation",
        description: "Entretien approfondi, examen clinique et analyse de vos examens. Nous discutons ensemble des options."
      },
      {
        step: 3,
        title: "Examens complémentaires",
        description: "Si nécessaire, des examens supplémentaires peuvent être prescrits pour affiner le diagnostic."
      },
      {
        step: 4,
        title: "Décision partagée",
        description: "Nous décidons ensemble de la meilleure prise en charge, chirurgicale ou non."
      },
      {
        step: 5,
        title: "Suivi",
        description: "Consultations de contrôle pour assurer votre bonne récupération et répondre à vos questions."
      }
    ]
  }
};

export const legalContent = {
  mentions: {
    title: "Mentions légales",
    items: [
      "Responsable de la publication : Dr LOUNIS KHODJA Mounir Abderrahmane",
      "Profession : Médecin chirurgien",
      "Inscription à l'Ordre des Médecins : Conseil de l'Ordre des Médecins d'Alger",
      "Adresse : 1, bâtiment A cité Armaf, El Magharia, Hussein Dey, Alger"
    ]
  },
  ethics: {
    title: "Éthique et déontologie",
    text: "Ce site respecte les recommandations du Conseil National de l'Ordre des Médecins concernant la communication des médecins. Aucune information présente sur ce site ne constitue une publicité au sens commercial du terme. Le contenu est fourni à titre informatif et éducatif uniquement."
  },
  privacy: {
    title: "Protection des données",
    text: "Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification et de suppression de vos données personnelles. Pour exercer ces droits, contactez le cabinet."
  },
  disclaimer: {
    title: "Avertissement médical",
    text: "Les informations contenues sur ce site sont fournies à titre informatif et ne remplacent en aucun cas une consultation médicale. Chaque situation est unique et nécessite un avis médical personnalisé. En cas d'urgence, contactez le 15 (SAMU) ou rendez-vous aux urgences les plus proches."
  }
};
